export const BRAND_NAME = "OpenClaw Marketplace";
export const BRAND_SLUG = "openclawmarketplace";
export const VISIBLE_LOGO_SRC = "/imgs/logos/clawhost-logo.svg";
export const SQUARE_LOGO_SRC = "/imgs/logos/logo.png";
export const SQUARE_LOGO_SVG_SRC = "/imgs/logos/logo.svg";
export const PRIMARY_DOMAIN = "openclawmarketplace.xyz";
export const PRIMARY_URL = `https://${PRIMARY_DOMAIN}`;
export const SUPPORT_EMAIL = `support@${PRIMARY_DOMAIN}`;
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
